import { render } from "./ServiceFlight.vue?vue&type=template&id=31600c97"
import script from "./ServiceFlight.vue?vue&type=script&lang=js"
export * from "./ServiceFlight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__